// extracted by mini-css-extract-plugin
export var actionItem = "Quote-module--actionItem--d41f6";
export var actions = "Quote-module--actions--3c742";
export var document = "Quote-module--document--cce05";
export var speech = "Quote-module--speech--c8f64";
export var text = "Quote-module--text--47133";